import {CommonResponse, BaseRequestParams, instance} from "./API"
import {AxiosResponse} from "axios"
import {filterToString} from "../helps/filterToString"
import {UserRolesResponse} from "../models/response"

export const userRoleApi = {
    getUserRoles(params: GetUserRole): Promise<CommonResponse<UserRolesResponse>> {
        const paramsString = filterToString(params)
        return instance.get(`UserType${paramsString}`, {signal: params?.controller?.signal}).then((res: AxiosResponse) => res.data)
    },
}

export type GetUserRole = {
    isSystem?: -1 | 0 | 1
} & BaseRequestParams